import Icons from "../../assets/icon";
import { SmAnimatespin } from "../../components/index";
import Functions from "./index.function";
const PostListTable = ({
  title,
  data,
  requestTitle,
  setJobIdToDelete,
  setConfirmDeleteJob,
  loadingToapi,
}) => {
  const {
    colCount,
    gridStyle,
    navigate,
    isCheckedMap,
    handleCheckboxChange,
    dispatch,
  } = Functions(data, title);
  return (
    <div className="">
      {data?.length > 0 ? (
        <div className="w-full overflow-x-auto xs:overflow-x-scroll custom-scrollbar">
          <div
            className={`grid grid-cols-${colCount} lg:min-w-[1000px] sm:min-w-[900px] xs:min-w-[700px] text-secondary bg-[#1A1A1A] px-5 py-3 xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular`}
            style={gridStyle}
          >
            {title.map((value, index) => (
              <div
                key={index}
                className={`flex items-center xs:gap-x-2 sm:gap-x-2.5 ${
                  index === title.length - 1 ? "justify-center" : ""
                }`}
              >
                {value}
                {/* <img
                  src={Icons.tableTitleIcon}
                  alt="chat"
                  className={`xs:w-3 xs:h-3 sm:w-3 sm:h-3 lg:w-4 lg:h-4 xl:w-5 xl:h-5 ${
                    index === title.length - 1 ? "hidden" : "block"
                  }`}
                /> */}
              </div>
            ))}
          </div>
          {data?.map((value, index) => (
            <div
              key={index}
              className={`grid grid-cols-${colCount} lg:min-w-[1000px] sm:min-w-[900px] xs:min-w-[700px] text-secondary rounded-lg my-4 px-5 py-4 gap-3 items-center ${
                index % 2 === 0 ? "bg-[#2A2A2A]" : "bg-transparent"
              } ${
                value?.applied_users_count >= 1
                  ? "cursor-pointer"
                  : "cursor-default"
              }`}
              onClick={() => {
                if (value?.applied_users_count >= 1) {
                  navigate("/emp-applicants-list");
                  dispatch({
                    type: "UPDATE_APPLICANTS_LISTS",
                    payload: { applicants: value?.id },
                  });
                }
              }}
              style={gridStyle}
            >
              <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                {value?.company?.name}
              </div>
              <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                {value?.title}
              </div>
              <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                {value?.job_types?.job_type}
              </div>
              <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                {value?.salary_from}
              </div>
              <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                {value?.salary_to}
              </div>
              <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                {value?.country?.country}
              </div>
              <div className=" flex items-center flex-col justify-center">
                <div className="flex justify-center items-center xs:gap-x-1 sm:gap-x-2">
                  <img
                    src={Icons.jobviewsCountesIcon}
                    alt="jobviewsCountesIcon"
                    className="xs:w-3 xs:h-3 sm:w-3 sm:h-3 lg:w-4 lg:h-4 xl:w-[18px] xl:h-[18px]"
                  />
                  <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                    {value?.view_count}
                  </div>
                </div>
                <div className="flex justify-center items-center xs:gap-x-1 sm:gap-x-2">
                  <img
                    src={Icons.jobappliedCountIcon}
                    alt="jobappliedCountIcon"
                    className="xs:w-3 xs:h-3 sm:w-3 sm:h-3 lg:w-4 lg:h-4 xl:w-[18px] xl:h-[18px]"
                  />
                  <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                    {value?.applied_users_count}
                  </div>
                </div>
              </div>
              <div className="flex justify-center items-center xs:gap-x-1 sm:gap-x-2">
                <img
                  src={Icons.favoritesCountIcon}
                  alt="favoritesCountIcon"
                  className="xs:w-3 xs:h-3 sm:w-3 sm:h-3 lg:w-4 lg:h-4 xl:w-[18px] xl:h-[18px]"
                />
                <div className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular">
                  {value?.saved_jobs_count}
                </div>
              </div>
              <label
                className="flex cursor-pointer select-none items-center"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="relative">
                  <input
                    type="checkbox"
                    checked={!!isCheckedMap[value.id]}
                    onChange={() => handleCheckboxChange(value.id)}
                    className="sr-only"
                  />
                  <div className="xs:h-3.5 xs:w-10 sm:h-4 sm:w-12 lg:h-4 lg:w-12 rounded-full shadow-inner transition-colors duration-300 bg-[#3E3E3E]"></div>
                  <div
                    className={`dot shadow-switch-1 absolute sm:-top-1 xs:!-top-[3px] xs:w-5 xs:h-5 sm:w-6 sm:h-6 lg:h-6 lg:w-6 rounded-full transition duration-300 ${
                      isCheckedMap[value.id]
                        ? "translate-x-full bg-[#D9A239]"
                        : "bg-secondary"
                    }`}
                  ></div>
                </div>
              </label>
              <div className=" xs:text-[10px] sm:text-xs lg:text-sm xl:text-base truncate font-onestRegular flex items-center justify-center xs:gap-1 sm:gap-2">
                <div
                  className=" bg-[#3E3E3E] xs:p-1.5 sm:p-2 lg:p-2.5 rounded-full cursor-pointer"
                  onClick={(event) => {
                    event.stopPropagation();
                    setConfirmDeleteJob(true);
                    setJobIdToDelete(value?.id);
                  }}
                >
                  <div>
                    {loadingToapi === value?.id ? (
                      <SmAnimatespin />
                    ) : (
                      <img
                        className="xs:w-3 xs:h-3 sm:w-4 sm:h-4 lg:w-5 lg:h-5"
                        src={Icons?.binIcon}
                        alt="binIcon"
                      />
                    )}
                  </div>
                </div>
                <div
                  className=" bg-[#3E3E3E] xs:p-2 sm:p-2.5 lg:p-3 rounded-full cursor-pointer"
                  onClick={(event) => {
                    event.stopPropagation();
                    dispatch({
                      type: "UPDATE_JOB_ID_DATA",
                      payload: { jobId: value?.id },
                    });
                    navigate("/update-job");
                  }}
                >
                  <img
                    className="xs:w-2 xs:h-2 sm:w-3 sm:h-3 lg:w-4 lg:h-4"
                    src={Icons?.editIcon}
                    alt="editIcon"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <p className="text-secondary capitalize text-center">
          No {requestTitle} request available.
        </p>
      )}
    </div>
  );
};
export default PostListTable;
